import React from 'react';
import { motion } from 'framer-motion';
import { HeartIcon, BrainIcon, SparklesIcon, SunIcon } from 'lucide-react';
import { staggerContainer, fadeInScale } from '../utils/animations';
const audienceItems = [{
  text: 'Personas que se sienten emocionalmente agotadas',
  icon: HeartIcon
}, {
  text: 'Personas que luchan contra la depresión',
  icon: BrainIcon
}, {
  text: 'Personas que buscan mejorar su bienestar mental',
  icon: SparklesIcon
}, {
  text: 'Personas que quieren transformar su vida emocional',
  icon: SunIcon
}];
export function AudienceSection() {
  return <section className="py-28 md:py-32 px-4 bg-[#F7F3E9] relative overflow-hidden" data-id="element-16">
      {/* Decorative Orb */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-[#7FB77E]/10 via-transparent to-transparent blur-3xl pointer-events-none" data-id="element-17"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-19">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif text-[#2F3A3D] mb-6" data-id="element-20">
            Para quién es este libro
          </h2>
          <p className="text-xl text-[#F4A261] font-serif italic" data-id="element-21">
            Este ebook es ideal para:
          </p>
        </motion.div>

        <motion.div variants={staggerContainer} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-22">
          {audienceItems.map((item, index) => {
          const Icon = item.icon;
          return <motion.div key={index} variants={fadeInScale} className="flex flex-col items-center text-center p-10 bg-white rounded-3xl shadow-[0_10px_30px_rgba(47,58,61,0.08)] border border-[#E8E1D5]" data-id="element-23">
                <div className="w-20 h-20 rounded-[1.5rem] bg-[#F7F3E9] border border-[#E8E1D5] flex items-center justify-center mb-8 text-[#F4A261]" data-id="element-24">
                  <Icon className="w-10 h-10" data-id="element-25" />
                </div>
                <p className="text-lg text-[#5F6368] font-medium leading-relaxed" data-id="element-26">
                  {item.text}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}